export default function convertImageUrl(url) {
    const parts = url?.split('/');

    let fileName = parts?.pop();
    fileName = fileName?.split('.')[0];

    parts?.push('thumb', '800_' + fileName + '.webp');
    return parts?.join('/');
}